import React from 'react';
import { Loader2, ShoppingBag } from 'lucide-react';

export default function OrderSummary({ summary, loading }) {
  if (loading) {
    return (
      <div className="pg-admin-card rounded-[var(--pg-radius-md)] p-6 flex items-center gap-3">
        <Loader2 size={18} className="animate-spin text-[var(--pg-gold-2)]" />
        <p className="text-sm text-[var(--pg-ink-muted)] font-mono">Preparing your order…</p>
      </div>
    );
  }
  if (!summary) return null;

  const currency = (summary.currency || 'usd').toUpperCase();
  const money = (n) => {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(n || 0)); }
    catch { return `${currency} ${Number(n || 0).toFixed(2)}`; }
  };

  return (
    <div className="pg-admin-card rounded-[var(--pg-radius-md)] overflow-hidden" data-testid="order-summary">
      <div className="px-5 pt-5 flex items-center gap-2">
        <ShoppingBag size={14} className="text-[var(--pg-gold-2)]" />
        <p className="pg-label text-[10px]">ORDER SUMMARY</p>
      </div>
      <div className="px-5 py-4 flex gap-4 items-start">
        {summary.image ? (
          <img src={summary.image} alt="" className="w-20 h-20 rounded-[var(--pg-radius-sm)] object-cover flex-shrink-0" />
        ) : (
          <div className="w-20 h-20 rounded-[var(--pg-radius-sm)] bg-[rgba(255,255,255,0.04)] flex items-center justify-center text-[var(--pg-ink-faint)]">
            <ShoppingBag size={22} />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <p className="font-serif text-base text-[var(--pg-ink)]">{summary.title || 'Item'}</p>
          {summary.description && (
            <p className="text-[11px] text-[var(--pg-ink-muted)] mt-1 line-clamp-3" dangerouslySetInnerHTML={{ __html: summary.description }} />
          )}
          <p className="text-[10px] font-mono tracking-widest uppercase text-[var(--pg-ink-faint)] mt-2">
            {summary.fulfillment_provider ? `${summary.fulfillment_provider}` : 'digital'} · qty {summary.quantity || 1}
          </p>
        </div>
      </div>

      <div className="px-5 pb-5 pt-3 border-t border-[var(--pg-border-2)] space-y-2">
        <div className="flex items-center justify-between text-[12px] font-mono text-[var(--pg-ink-muted)]">
          <span>Subtotal</span><span className="text-[var(--pg-ink)]">{money(summary.subtotal)}</span>
        </div>
        {(summary.discount_amount || 0) > 0 && (
          <div className="flex items-center justify-between text-[12px] font-mono text-[var(--pg-emerald-2)]">
            <span>Discount</span><span>− {money(summary.discount_amount)}</span>
          </div>
        )}
        <div className="flex items-center justify-between pt-2 border-t border-[var(--pg-border-2)]">
          <span className="pg-label text-[10px]">TOTAL</span>
          <span className="font-serif text-2xl text-[var(--pg-ink)]">{money(summary.total)}</span>
        </div>
      </div>
    </div>
  );
}
